import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Dados } from '../../model/dados.model';
import { OfertasState } from './ofertas-state';
import { Store } from '../../store/store';

import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OfertasService extends Store<OfertasState>{

  constructor(private http: HttpClient) {

    super({});

  }

  public getData() {
    return this.http.get<Dados>(environment.API.concat("summary_negotiations"), {
      headers: new HttpHeaders({
        'X-Application-Key': environment.clientId
      })
    }).pipe(
      retry({ count: 2, delay: 3000 }),
      catchError(this.handlerError)
    ).subscribe({
      next: (data) => {
        if (data["_content"].length > 0) {
          this.setState({
            ...this.state,
            resultado: data["_content"][0]
          });
        }
      },
      error: (err) => {
        // Error handling without logging
      }
    });
  }


  handlerError(error: any): Observable<never> {
    let errorMessage = '';

    errorMessage = error.error instanceof ErrorEvent ? error.error.message : `Error Code: ${error.status} \n Message: ${error.message}`;

    return throwError(errorMessage);
  }
}
